import axios from "axios";
import { GET_ALL_PHYSICALLYCHALLENGE_CATEGORY } from "./types";
const keys = require("../config/keys");

export const getAllPhysicallyChallengeCategory = () => async dispatch => {
  await axios({
    method: "get",
    url:
      keys.ServicePath + "/api/AdmissionForm/GetAllPhysicallyChallengeCategory"
  })
    .then(res => {
      if (res.data.success) {
        try {
          dispatch({
            type: GET_ALL_PHYSICALLYCHALLENGE_CATEGORY,
            payload: res.data.data
          });
        } catch (exc) {
          console.log("exception", exc);
        }
      }
    })
    .catch(e => {
      console.log("catch error", JSON.stringify(e));
    });
};



// WEBPACK FOOTER //
// ./src/actions/getAllPhysicallyChallengeCategory.js